import React from "react";

const iconLayouts = color => ({
  removeButton: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0.375C4.6375 0.375 0.375 4.6375 0.375 10C0.375 15.3625 4.6375 19.625 10 19.625C15.3625 19.625 19.625 15.3625 19.625 10C19.625 4.6375 15.3625 0.375 10 0.375ZM13.7125 14.8125L10 11.1L6.2875 14.8125L5.1875 13.7125L8.9 10L5.1875 6.2875L6.2875 5.1875L10 8.9L13.7125 5.1875L14.8125 6.2875L11.1 10L14.8125 13.7125L13.7125 14.8125Z" fill="#707070"/>
    </svg>
  ),
});

const PatientOnboardingIcon = ({ onClick, className, type }) => {
  const icon = iconLayouts("#707070")[type];
  return <span>{icon}</span>;
};

export default PatientOnboardingIcon;
